'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _viewport = require('@aveneo/frontmoon-utils/lib/viewport');

var _viewport2 = _interopRequireDefault(_viewport);

var _lib = require('@aveneo/frontmoon-di/lib');

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewportWatcher = function (_Component) {
    _inherits(ViewportWatcher, _Component);

    function ViewportWatcher() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ViewportWatcher);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewportWatcher.__proto__ || Object.getPrototypeOf(ViewportWatcher)).call.apply(_ref, [this].concat(args))), _this), _this.setViewportState = function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                breakpoint = _ref3[0],
                orientation = _ref3[1];

            _this.props.changeViewport(breakpoint, orientation);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ViewportWatcher, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var VIEWPORT_WATCHER_SETTINGS = this.context.container.VIEWPORT_WATCHER_SETTINGS;


            _viewport2.default.set(_extends({}, VIEWPORT_WATCHER_SETTINGS.BREAKPOINTS, VIEWPORT_WATCHER_SETTINGS.ORIENTATIONS));
            _viewport2.default.onChange(this.setViewportState);
            this.setViewportState(_viewport2.default.state);
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);

    return ViewportWatcher;
}(_react.Component);

ViewportWatcher.propTypes = {
    changeViewport: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.object
};


ViewportWatcher.contextType = _lib2.default;

exports.default = ViewportWatcher;